import React, { useId } from 'react';

import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import BottomSheet from '@rover/kibble/official-patterns/BottomSheet/BottomSheet';
import A11yHiddenBox from '@rover/kibble/styles/A11yHiddenBox';

import RevampDatesPicker, { DateRange, DateSelection } from './RevampDatesPicker';

const MONTHS_SHOWN = 2;

export type { DateRange, DateSelection };

type Props = DateSelection & {
  isOpen: boolean;
  onClose: () => void;
  onSave: (selection: DateSelection) => void;
  locale: Locale;
  allowsLooseDates?: boolean;
  allowsRecurring?: boolean;
};

const RevampDatesSheet = ({
  isOpen,
  onClose,
  onSave,
  locale,
  startDate,
  endDate,
  dates,
  isRecurring,
  weekDays,
  allowsLooseDates,
  allowsRecurring,
}: Props): JSX.Element => {
  const headingId = useId();

  return (
    <BottomSheet isOpen={isOpen} onRequestClose={onClose} headerId={headingId}>
      <A11yHiddenBox webAs="h2" id={headingId}>
        {/* TODO: Pending translations. Address in DEV-157125 */}
        Select dates
      </A11yHiddenBox>
      <RevampDatesPicker
        isOpen={isOpen}
        onClose={onClose}
        onSave={onSave}
        locale={locale}
        startDate={startDate}
        endDate={endDate}
        dates={dates}
        isRecurring={isRecurring}
        weekDays={weekDays}
        allowsLooseDates={allowsLooseDates}
        allowsRecurring={allowsRecurring}
        monthsShown={MONTHS_SHOWN}
        isMobileBrowser
        testID="revamp-dates-sheet"
      />
    </BottomSheet>
  );
};

export default RevampDatesSheet;
